import { isRequestError } from 'utils/requestError';
import { Button, InputWraper, useForm } from 'modules';
import React from 'react';
import {
  AcceptRequestWithdrawType,
  useApproveRequestWithdrawMutation,
  useUploadApproveRequestWithdrawMutation,
} from 'services';
import { InputText, InputNumber } from 'components';

import { PopupWraper } from 'components';
import { WithdrawRequestEntity } from 'services/openapi';
import { toast } from 'react-hot-toast';
import { useState } from 'react';
import AvatarUploader from 'components/AvatarUploader';
import { Loading } from 'components';
interface AcceptRequestWithdrawProps {
  onClose: () => void;
  forceUpdateTable: () => void;
  data: WithdrawRequestEntity | null;
}

const ApproveRequestWithdraw = ({
  onClose,
  forceUpdateTable,
  data,
}: AcceptRequestWithdrawProps) => {
  const { mutateAsync, isLoading: isLoadingApproveRequestWithdrawMutation } =
    useApproveRequestWithdrawMutation();

  const {
    isLoading: isLoading,
    mutateAsync: mutateUploadApproveRequestWithdrawAsync,
  } = useUploadApproveRequestWithdrawMutation();
  const [avatarFile, setAvatarFile] = useState<File>();
  const { handleSubmit, getInputProps, resetForm, setValues } = useForm({
    structure: [
      {
        name: 'amount',
        label: 'Số tiền',
        defaultValue: data?.amount,
        isDisabled: true,
      },
      {
        name: 'bankAccountName',
        label: 'Tài khoản',
        defaultValue: data?.bankAccount?.accountName,
        isDisabled: true,
      },
      {
        name: 'bankName',
        label: 'Ngân hàng',
        defaultValue:
          data?.bankAccount?.bank?.shortName +
          ' - ' +
          data?.bankAccount?.bank?.name,
        isDisabled: true,
      },
      {
        name: 'bankAccount',
        label: 'Số tài khoản',
        defaultValue: data?.bankAccount?.accountNumber,
        isDisabled: true,
      },
    ],
    onSubmit: async (values) => {
      try {
        let dataMutateAvatarAsync;
        if (avatarFile) {
          // AN STT UPD
          // await mutateAvatarAsync({ extention: avatarFile?.type as string, file: avatarFile as File });
          let fileExtension = avatarFile?.type.substring(
            avatarFile?.type.indexOf('/') + 1,
            avatarFile?.type.length,
          );
          dataMutateAvatarAsync = await mutateUploadApproveRequestWithdrawAsync(
            {
              id: data?.id,
              param: { extention: fileExtension as string },
              file: avatarFile as File,
            },
          );
        } else {
          toast.error('Vui lòng chọn ảnh');
          return;
        }
        const normalizedValues = {
          transactionImageUrl: dataMutateAvatarAsync?.url ?? '',
        };
        const request: AcceptRequestWithdrawType = {
          id: data?.id ?? '',
          variables: normalizedValues,
        };
        await mutateAsync(request);
        resetForm();
        forceUpdateTable();
        onClose();
        toast.success('Duyệt yêu cầu rút tiền thành công');
      } catch (error: any) {
        if (!isRequestError(error)) {
          toast.error(error.message);
        }
        console.log('error', error);
      }
    },
  });

  return (
    <div className='wrap-pop-up-create-user'>
      <PopupWraper
        center
        title='Duyệt yêu cầu rút tiền'
        onClose={() => onClose()}
      >
        <div className='container-fluid'>
          <div className='wrap-form-accept-request'>
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('amount')}
              component={InputNumber}
            />
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('bankAccountName')}
              component={InputText}
            />
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('bankName')}
              component={InputText}
            />
            <InputWraper
              className='col-lg-12'
              inputProps={getInputProps('bankAccount')}
              component={InputText}
            />
            <div className='text-center-upload-image'>
              Upload ảnh giao dịch (*)
            </div>
            <div className='wrap-upload-image'>
              <Loading isLoading={isLoading}>
                <AvatarUploader onChangeCallback={setAvatarFile} />
              </Loading>
            </div>
          </div>
        </div>
        <div className='wrap-button-create-user'>
          <Button
            label='Duyệt'
            type='submit'
            onClick={handleSubmit}
            buttonType='success'
            isLoading={isLoadingApproveRequestWithdrawMutation}
          />
          <Button label='Trở về' buttonType='grey' onClick={() => onClose()} />
        </div>
      </PopupWraper>
    </div>
  );
};

export default ApproveRequestWithdraw;
